module.exports = __webpack_public_path__ + "img/dianhua@3x.2e4821e7.svg";